import React from 'react';
import "./about.css";

export default function About() {
  const capabilities = [
    {
      category: 'AI & Machine Learning',
      items: ['PyTorch & TensorFlow', 'Deep Learning Architectures', 'Computer Vision / CNNs', 'Natural Language Processing', 'Explainable AI (XAI)']
    },
    {
      category: 'LLM Engineering',
      items: ['LangGraph & LangChain', 'Multi-Agent State Workflows', 'Vector Embeddings & Indices', 'Retrieval-Augmented Gen (RAG)', 'Ragas Evaluation Testing']
    },
    {
      category: 'Backend Engineering',
      items: ['FastAPI (Asynchronous)', 'Django Framework', 'REST API Architectures', 'Server-Sent Events (SSE)', 'System Design & Scaling']
    },
    {
      category: 'Databases & Vector Storage',
      items: ['PostgreSQL', 'Supabase Platform', 'FAISS Vector Indexing', 'pgvector Integration', 'Data Schema Normalization']
    },
    {
      category: 'DevOps & MLOps',
      items: ['Docker Containerization', 'GitHub Actions (CI/CD)', 'Model Deployment Gateways', 'Cloud VPS Configurations', 'Performance Logging']
    },
    {
      category: 'Product Development',
      items: ['React.js Development', 'SaaS Product Architecture', 'Responsive UI Engineering', 'State Management', 'Frictionless Conversion Flows']
    }
  ];

  return (
    <div className="about-page-container">
      {/* Intro Profile */}
      <div className="about-intro-grid">
        <div className="about-bio">
          <span className="section-tag">About Me</span>
          <h1>Bridging AI Research & Software Engineering</h1>
          <h2>I write code that turns intelligent models into production-ready platforms.</h2>
          <p>
            I am an AI Engineer and Full-Stack Developer specializing in design patterns that keep language models and machine learning pipelines robust. I focus on agent state orchestration, optimized vector databases, and responsive, async backends.
          </p>
          <p>
            Instead of building toys or treating LLMs as magical black boxes, I design deterministic validation systems, cost-conscious token retrieval channels, and self-correcting pipelines that address real enterprise requirements.
          </p>

          <div className="about-philosophy-card premium-card">
            <h3>My Philosophy</h3>
            <p>
              "Reliability is the ultimate feature of any AI system. A model that is 95% accurate but fails silently is worse than a simpler model that fails predictably. I build loops, validations, and tests around models so they behave like robust software."
            </p>
          </div>
        </div>

        <div className="about-visual-panel">
          <div className="visual-item">
            <h4>[01] Build for Latency</h4>
            <p>Users shouldn't wait on LLM tokens. I leverage async routes, SSE streaming, and caching layer configurations.</p>
          </div>
          <div className="visual-item">
            <h4>[02] Grounded RAG</h4>
            <p>Retrievals must be verified. I write evaluation loops comparing citations and source overlaps.</p>
          </div>
          <div className="visual-item">
            <h4>[03] Modular Architecture</h4>
            <p>Isolate agents from client UI. Loose component coupling yields maintainable and testable codebases.</p>
          </div>
        </div>
      </div>

      {/* Technical Capabilities Framework */}
      <div className="skills-capabilities-section">
        <span className="section-tag">Skills Framework</span>
        <h2 className="section-title">Technical Capabilities</h2>
        <p className="section-subtitle" style={{ textAlign: 'left', margin: '0 0 2rem 0' }}>
          An outcome-focused grid displaying languages, developer toolsets, and architectural structures I specialize in.
        </p>

        <div className="skills-grid">
          {capabilities.map((cap, index) => (
            <div className="skill-category-card premium-card" key={index}>
              <h3>{cap.category}</h3>
              <ul className="skill-list">
                {cap.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}